import API from '../../../services/apiService.js'

var api= new API();


export default {

// Загрузить данные справочника
    async loadOrganizations ({ commit }) {
        var data=null;
        try{
            data = await api.Get("OrganizationService/Organization");
            commit('loadOrgs', data);
        }catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

  //загрузить изображение
  async loadImage({commit}, postData){
    var data=null;
    try{
      console.log(postData)
      data = await api.PostImage(postData);
      console.log(data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //загрузить изображение
  async loadImageApp({commit}, postData){
    var data=null;
    try{
      data = await api.PostImageApp(postData);
      console.log(data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //добавить
  async addOrganization({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      newId = await api.Post("OrganizationService/Organization", data);
      if (newId != null) {
        var getparams = '?Id=' + newId.id;
        newData = await api.Get("OrganizationService/Organization/GetById" + getparams)
      }
      if (newData != null && newData != "")
        commit('addPartner', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

    //Добавить нового партнера в сетку
    async addPartnerToGrid({commit}, data){
        try{
            const newId= await api.Post("OrganizationService/OrgBusinessGrid", data)
            if (newId != null){
                console.log("Success")
            }
        }catch(e){
            console.log(e)
            throw new Error(e)
        }
    },

  //редактировать
  async editOrganization({commit}, data) {
    var newData = null;
    try {
      await api.Put("OrganizationService/Organization", data);
      var getparams = '?Id=' + data.id;
      newData = await api.Get("OrganizationService/Organization/GetById" + getparams)

      if (newData != null && newData != "")
        commit('edit', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //удалить
  async deleteOrganization({commit}, id) {
    try {
      var getparams = '?OrganizationId=' + id;
      await api.Delete("OrganizationService/Organization", getparams);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },
    //Удаляем партнерскую организацию из сетки партнеров
    async removePartnerFromGrid({commit}, id){
      try{
          const getParams = `?OrganizationId=${id}`
          await api.Delete('OrganizationService/OrgBusinessGrid', getParams)
          commit("deletePartnerFromGrid", id)
      }catch(e){
          console.log(e);
          throw new Error(e);
      }
    },

    //Получить список филиалов
    async getPartnerBranches ({commit}, partnerId){
    let data=null;
    try {
            var getparams = '?OrganizationId=' + partnerId;
        data = await api.Get("OrganizationService/OrgGeoInfo/GetAllByOrgId"+ getparams);
            commit('loadBranches',data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
        console.log(data)
    },


    //Получить список сотрудников
    async getPartnerStaff ({commit}, partnerId){
        let data=null;
        try {
            var getparams = '?organizationId=' + partnerId;
            data = await api.Get("UserService/WebUser/GetByOrgId"+ getparams);
            commit('loadStaff',data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //Получить список уровней доступа
    async getUserAccessLevels ({commit}, partnerId){
        let data=null;
        try {
            var getparams = '?organizationId=' + partnerId;
            data = await api.Get("UserService/WebUserAccessLevel");
            commit('loadAccessLevels',data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //олучить список сотрудников по уровню доступа
    async getStaffByLevel ({commit}) {
        let data = null;
        try {
            data = await api.Get("UserService/WebUser/GetByAccessLevel");
            commit('loadStaff', data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    async getStocks({commit}, partnerId){
        let data=null;
        try {
            var getparams = '?OrgId=' + partnerId;
            data = await api.Get("InformationService/Stock/GetOrgPublished"+ getparams);
            commit('loadStock',data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    async getActivations({commit}, partnerId){
        let data=null;
        try {
            var getparams = '?OrgId=' + partnerId;
            data = await api.Get("BonusService/BonusActivation/GetCompletedOrgBonuses"+ getparams);
            commit('loadActivations',data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },
    //получаем данные о сетке партнеров с сервера
    async getPartnerGrid({commit}, partnerId){
        let data = null;
        try{
            const getParams = `?Id=${partnerId}`
            data = await api.Get(`OrganizationService/OrgBusinessGrid/GetByMainOrgId${getParams}`)
            commit('loadPartnerGrid', data)
        }catch (e){
            console.log(e);
            throw new Error(e);
        }
    },
}
